import React, { useState } from "react";
import { Share2, Copy, Check } from "lucide-react";
import { toast } from "sonner";

export default function ShareButtons({ title, text, hashtags = ["Shiva", "PanchamDham"], url, compact = false }) {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const encodedText = encodeURIComponent(`${text}\n\n${shareUrl}`);
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedHash = hashtags.join(",");

  const copy = () => {
    navigator.clipboard.writeText(`${text}\n\n${shareUrl}`);
    setCopied(true);
    toast.success("Copied — paste in any app");
    setTimeout(() => setCopied(false), 1800);
  };

  const native = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, text, url: shareUrl }); } catch (_) {}
    } else copy();
  };

  const links = [
    { k: "whatsapp", label: "WhatsApp", bg: "#25D366", color: "#fff", href: `https://wa.me/?text=${encodedText}` },
    { k: "twitter", label: "X", bg: "#000", color: "#fff", href: `https://twitter.com/intent/tweet?text=${encodedText}&hashtags=${encodedHash}` },
    { k: "facebook", label: "Facebook", bg: "#1877F2", color: "#fff", href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}` },
    { k: "telegram", label: "Telegram", bg: "#0088cc", color: "#fff", href: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}` },
  ];

  if (compact) {
    return (
      <button data-testid="share-compact" onClick={native} className="btn-ghost-gold text-sm">
        <Share2 className="w-4 h-4" /> Share
      </button>
    );
  }

  return (
    <div data-testid="share-buttons" className="flex flex-wrap items-center gap-2">
      <span className="overline mr-2 hidden sm:inline">Share this blessing</span>
      {links.map((l) => (
        <a
          key={l.k}
          data-testid={`share-${l.k}`}
          href={l.href}
          target="_blank"
          rel="noopener noreferrer"
          className="h-10 px-4 rounded-full text-sm font-semibold flex items-center gap-2 transition-sacred hover:scale-105"
          style={{ background: l.bg, color: l.color }}
        >
          {l.label}
        </a>
      ))}
      <button data-testid="share-copy" onClick={copy} className="h-10 px-4 rounded-full text-sm font-semibold flex items-center gap-2 bg-[#4A0E17] text-[#F3E5AB] hover:bg-[#36080F] transition-sacred">
        {copied ? <><Check className="w-4 h-4" /> Copied</> : <><Copy className="w-4 h-4" /> Copy</>}
      </button>
    </div>
  );
}
